<app-page class="width-100">
  <div class="home-page" [style.height]="getPageHeight()">
    <app-summary-cards (dataLoaded)="getAccordionData()" />
    <app-button
      icon="pi pi-download"
      label="Save All For Offline"
      [text]="true"
      [outlined]="true"
      (click)="saveAllVisible = true"
    />
    @if (loadAccordions()) {
    <app-accordions [getData]="true" />
    } @else {
    <app-accordions [getData]="false" />
    } @if (saveAllVisible) {
    <app-save-all [(visible)]="saveAllVisible" />
    }
  </div>
</app-page>
